// import CustomizedInputs from 'component/FormElement/TextField'
// import CustomizedButtons from 'component/Button'
// import Logo from 'assets/images/club-car-connect-logo.png'
import * as React from "react";
import { useState, useEffect } from "react";
import Logo from "../../../assets/images/club-car-connect-logo.png";
import {
  Container,
  PageTitle,
  InputBoxWrapper,
  Wrapper,
} from "../UserAuthStyled";
import CustomizedButtons from "commonComponents/Button";
// modal imports
//  material UI imports starts
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";

// redux imports starts
import { useDispatch, useSelector } from "react-redux";
import { COMMON_SERVICES } from "redux/reduxToolkitServices/_commonServices/commonServices";

// redux imports ends
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  maxWidth: "400px",
  width: "calc(100% -  40px)",
  bgcolor: "background.paper",
  border: "1px solid #000",
  boxShadow: 24,
  p: 4,
  borderRadius: "5px",
  alignItems: "center",
  justifyContent: "center",
  display: "flex",
  flexDirection: "column",
};

export const ForgetPassword = (props) => {
  const dispatch = useDispatch();
  // modal design starts
  const [open, setOpen] = React.useState(false);
  const [email, setEmail] = useState("");
  // const [error, setError] = useState("");
  const [error, setError] = useState({
    email: false,
    incorrect: false,
  });

  const {
    verficationLinkData: resetDataInfo,
    verficationLinkStatus: resetStatusInfo,
  } = useSelector((state) => state.commonReducers) || "";

  const handleClick = async (e) => {
    e.preventDefault();
    // setResMsg("")
    if (email !== "") {
      dispatch(COMMON_SERVICES.sendLinkToEmailForResetPasswordServices(email));
      // setOpen(true);
    } else {
      // alert("Please enter email");
      setError({ email: true });
    }
  };
  const handleClose = () => setOpen(false);

  const [resMsg, setResMsg] = useState("");

  useEffect(() => {
    if (resetStatusInfo === "success") {
      setResMsg(resetDataInfo);
      // setError({ incorrect: true });
    }
  }, [resetStatusInfo]);

  useEffect(() => {
    if (resMsg !== "") {
      resMsg === "User does not exist with entered email address."
        ? setError({ incorrect: true })
        : setOpen(true);
    }
  }, [resMsg]);

  return (
    <Container>
      <img src={Logo} alt="logo" className="logo" />
      <Wrapper>
        <PageTitle>Forgot Password</PageTitle>
        <form onSubmit={handleClick}>
          <InputBoxWrapper>
            <p>Enter your email address</p>
            <input
              type="email"
              id="email"
              label="Enter your email to reset your password"
              htmlFor="Enter your email here"
              placeholder="Enter your email here"
              value={email}
              onChange={(e) => {
                setEmail(e.target.value);
                setError({ email: false, incorrect: false });
              }}
            />
            {error.email && <div className="error">Please Enter Email</div>}
          </InputBoxWrapper>
          <div className="error">{error.incorrect && resMsg}</div>
          <CustomizedButtons
            title="Submit"
            type="submit"
          // onClick={handleClick}
          />
          {/* <span onClick={() => {setResMsg(""); navigate(-1) }} className="bottom-span"> */}
          <span
            onClick={() => (window.location.href = "/")}
            className="bottom-span"
          >
            Back to Login Page
          </span>
        </form>
      </Wrapper>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open}
        onClose={handleClose}
      // closeAfterTransition
      // BackdropComponent={Backdrop}
      // BackdropProps={{
      //   timeout: 500,
      // }}
      >
        <Fade in={open}>
          <Box sx={style}>
            {/* <Typography id="transition-modal-title" variant="h6" component="h2">
            {(resMsg === "") && <CircularProgress />}
            {(resMsg==="User does not exist with entered email address.") && 
            <GppBadIcon color="error" fontSize="large"  /> }
            {(resMsg!=="User does not exist with entered email address." && resMsg !== "") && 
            <img src={modal1} /> }
            </Typography> */}
            <Typography
              style={{ textAlign: "center", wordBreak: 'break-word' }}
              id="transition-modal-description"
              sx={{ mt: 2 }}
            >
              {resMsg}
            </Typography>
            {resMsg !== "User does not exist with entered email address." && (
              <Button
                variant="contained"
                style={{
                  marginTop: "1.5rem",
                  backgroundColor: "var(--theme-background)",
                  color: "#fff",
                  fontSize: "14px",
                  fontWeight: "500",
                  minWidth: "187px",
                  boxShadow: "none",
                  height: "41px",
                  borderRadius: "40px",
                }}
                className="button-Modal"
                // onClick={() => navigate(-1)}
                onClick={() => (window.location.href = "/")}
              >
                Proceed to Login
              </Button>
            )}
          </Box>
        </Fade>
      </Modal>
    </Container>
  );
};

// export default ForgetPassword;
